import { Skeleton } from "@circleco/compass/components/Skeleton";

import { SearchResultsSkeleton } from "./SearchResultsSkeleton";

export const SpotlightSearchBodySkeleton = () => (
  <div className="flex flex-1 flex-col pt-6">
    <Skeleton shape="pill" className="h-10 w-full" />
    <ul className="m-0 flex list-none flex-col gap-0.5 p-0 pt-4">
      <SearchResultsSkeleton />
    </ul>
  </div>
);
